(function ($) {
    $(function () {
        const dateFilter = $('.js-program-date-filter');
        const toggleLikedButton = $('.js-toggle-liked-programs');
        const programCard = $('.js-program-card');
        const modal = $('.js-program-filter-modal');
        const searchInputs = $('.js-program-search');
        const pill = $('.js-program-date-filter-pill');
        const filterAgeCheckbox = $('.js-checkbox-age');
        const filterTypeCheckbox = $('.js-checkbox-type');
        const currentProgramsCheckbox = $('.js-checkbox-current');
        const programCardContent = $('.js-program-card:visible .js-search-title');

        var selectedAges = [];
        var selectedTypes = [];
        var showLikedOnly = false;
        var showCurrentOnly = false; // Variable to track current-only filter status

        function initPill() {
            dateFilter.first().addClass('selected');
            pill.css('left', "8px");
            return;
        }

        function animatePill(selectedId) {
            var width = selectedId == 0 ? "8px" : selectedId * 25 + "%";
            var property = $(window).width() <= 767 ? 'top' : 'left';
            dateFilter.removeClass('selected');
            $('.js-program-date-filter[data-id=' + selectedId + ']').addClass('selected');

            if (selectedId == 3) {
                pill.css(property, 'calc(75% - 8px)');
            } else {
                pill.css(property, width);
            }
            return;
        }

        function countVisibleItems() {
            var visibleItems = programCard.not(':hidden').length;
            $('.js-filtered-programs-counter').html(visibleItems);
        }

        function updateMatchHeight() {
            $('.js-program-card-text-block').data("matchHeight", "false");
            $('.js-program-card-text-block').matchHeight({ remove: true });
            $('.js-program-card-text-block:visible').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        }

        function arraysHasCommonValues(firstArray, secondArray) {
            return firstArray.filter(e => secondArray.includes(e)).length > 0;
        }

        function loadAllPrograms() {
            programCard.addClass('filtered-by-date').parent().show();
        }

        function loadProgramsByDate(selectedDate) {
            programCard.each(function () {
                $(this).removeClass('filtered-by-date');
                var programCardDates = $(this).attr('data-program-times');
                if (programCardDates.includes(selectedDate)) {
                    $(this).addClass('filtered-by-date').parent().show();
                } else {
                    $(this).parent().hide();
                }
            });
        }

        function loadProgramsByAge(ageId = null) {
            if (ageId != null) {
                ageId = parseInt(ageId);
                if (!selectedAges.includes(ageId)) {
                    selectedAges.push(ageId);
                } else {
                    selectedAges = selectedAges.filter(e => e != ageId);
                }
            }

            programCard.each(function () {
                var programCardAges = $(this).attr('data-program-ages');
                $(this).removeClass('filtered-by-age');
                if ($('.filtered-by-type').length > 0) {
                    if (arraysHasCommonValues(JSON.parse(programCardAges), selectedAges) && $(this).hasClass('filtered-by-date') && $(this).hasClass('filtered-by-type')) {
                        $(this).addClass('filtered-by-age').parent().show();
                    } else {
                        $(this).parent().hide();
                    }
                } else if (arraysHasCommonValues(JSON.parse(programCardAges), selectedAges) && $(this).hasClass('filtered-by-date')) {
                    $(this).addClass('filtered-by-age').parent().show();
                } else {
                    $(this).parent().hide();
                }
            });
            return;
        }

        function loadProgramsByType(typeId = null) {
            if (typeId != null) {
                typeId = parseInt(typeId);
                if (!selectedTypes.includes(typeId)) {
                    selectedTypes.push(typeId);
                } else {
                    selectedTypes = selectedTypes.filter(e => e != typeId);
                }
            }

            programCard.each(function () {
                var programCardTypes = $(this).attr('data-program-types');
                $(this).removeClass('filtered-by-type');
                if ($('.filtered-by-age').length > 0) {
                    if (arraysHasCommonValues(JSON.parse(programCardTypes), selectedTypes) && $(this).hasClass('filtered-by-date') && $(this).hasClass('filtered-by-age')) {
                        $(this).addClass('filtered-by-type').parent().show();
                    } else {
                        $(this).parent().hide();
                    }
                } else if (arraysHasCommonValues(JSON.parse(programCardTypes), selectedTypes) && $(this).hasClass('filtered-by-date')) {
                    $(this).addClass('filtered-by-type').parent().show();
                } else {
                    $(this).parent().hide();
                }
            });
            return;
        }

        function loadProgramsByKeyword() {
            programCard.each(function () {
                var $this = $(this);
                var show = true;

                searchInputs.each(function () {
                    const search = $(this).val().toLowerCase().trim();
                    const title = $this.find('.js-search-title').text().toLowerCase();
                    if (show && !title.includes(search)) {
                        show = false;
                    }
                });

                if (show) {
                    $this.addClass('filtered-by-keyword').parent().show();
                } else {
                    $this.removeClass('filtered-by-keyword').parent().hide();
                }
            });
        }

        function loadCurrentPrograms() {
            const date = Math.floor(Date.now() / 1000);
            showCurrentOnly = !showCurrentOnly;

            programCard.each(function () {
                var $this = $(this);
                var show = false;

                // Check if the program is currently running
                var programTimestamps = $this.data('timestamp');
                programTimestamps.map(e => {
                    if (e.start <= date && e.end >= date) {
                        show = true;
                    }
                });

                if (show) {
                    $this.addClass('filtered-by-current');
                } else {
                    $this.removeClass('filtered-by-current');
                }
            });

            loadFilteredPrograms();
        }

        function loadFilteredPrograms() {
            programCard.each(function () {
                var $this = $(this);
                var show = true;

                // Filter by date
                var selectedDate = $('.js-program-date-filter.selected').data('date');
                if (selectedDate !== 'all') {
                    var programCardDates = $this.attr('data-program-times');
                    if (!programCardDates.includes(selectedDate)) {
                        show = false;
                    }
                }

                // Filter by age
                if (show && selectedAges.length > 0) {
                    var programCardAges = JSON.parse($this.attr('data-program-ages'));
                    if (!arraysHasCommonValues(programCardAges, selectedAges)) {
                        show = false;
                    }
                }

                // Filter by type
                if (show && selectedTypes.length > 0) {
                    var programCardTypes = JSON.parse($this.attr('data-program-types'));
                    if (!arraysHasCommonValues(programCardTypes, selectedTypes)) {
                        show = false;
                    }
                }

                // Filter by keyword
                if (show) {
                    searchInputs.each(function () {
                        const search = $(this).val().toLowerCase().trim();
                        const title = $this.find('.js-search-title').text().toLowerCase();
                        if (!title.includes(search)) {
                            show = false;
                        }
                    });
                }

                // Filter by liked
                if (showLikedOnly && !($this.hasClass('liked'))) {
                    show = false;
                }

                // Filter by current programs
                if (showCurrentOnly && !($this.hasClass('filtered-by-current'))) {
                    show = false;
                }

                if (show) {
                    $this.parent().show();
                } else {
                    $this.parent().hide();
                }
            });

            countVisibleItems();
            updateMatchHeight();
        }

        dateFilter.on('click', function (e) {
            e.preventDefault();
            var selectedId = $(this).data('id');
            var selectedDate = $(this).data('date');
            animatePill(selectedId);

            const url = new URL(window.location);
            url.searchParams.set('datum', selectedDate);
            history.pushState({}, '', url);

            loadFilteredPrograms();
        });

        filterAgeCheckbox.on('click', function () {
            var ageId = $(this).val();
            loadProgramsByAge(ageId);

            loadFilteredPrograms();
        });

        filterTypeCheckbox.on('click', function () {
            var typeId = $(this).val();
            loadProgramsByType(typeId);

            loadFilteredPrograms();
        });

        searchInputs.each(function () {
            $(this).on('input keyup paste', function () {
                const value = $(this).val();
                searchInputs.not(this).val(value); // Sync values across all search inputs
                loadFilteredPrograms();
            });
        });

        currentProgramsCheckbox.on('click', function () {
            loadCurrentPrograms();
        });

        toggleLikedButton.on('click', function () {
            showLikedOnly = !showLikedOnly;
            $(this).toggleClass('active');
            loadFilteredPrograms();
        });

        function applyFilterFromURL() {
            const urlParams = new URLSearchParams(window.location.search);
            const dateParam = urlParams.get('datum');

            if (dateParam) {
                dateFilter.each(function () {
                    if ($(this).data('date') == dateParam) {
                        $(this).trigger('click');
                    }
                });
                if ($(window).width() <= 767) {
                    dateFilter.hide();
                    $('.js-program-date-filter[data-date=' + dateParam + ']').show();
                }
            } else {
                initPill();
                loadAllPrograms();
                updateMatchHeight();
                countVisibleItems();
            }
        }

        $('.js-init-program-filter-modal').on('click', function (e) {
            modal.addClass('is-active');
        });

        $('.js-close-program-filter-modal, .js-checkbox-filter-show-programs').on('click', function (e) {
            modal.removeClass('is-active');
        });

        $('.js-checkbox-filter-accordion').on('click', function (e) {
            $(this).next('.js-checkbox-filter').toggleClass('is-visible');
        });

        if ($(window).width() <= 767) {
            dateFilter.slice(1).hide();
            dateFilter.on('click', function () {
                if (dateFilter.not(':hidden').length > 1) {
                    $(this).addClass('selected');
                    dateFilter.not($(this)).hide();
                    $('.js-program-filter-dropdown').css('transform', 'rotate(90deg)');
                } else {
                    dateFilter.show();
                    $('.js-program-filter-dropdown').css('transform', 'rotate(270deg)');
                }
            });
        }
        applyFilterFromURL();
    });
})(jQuery);
